import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { toast } from "react-toastify";
import { complaintService } from "../services/complaintService";
import LoadingSpinner from "../components/common/LoadingSpinner/LoadingSpinner";
import ErrorAlert from "../components/common/ErrorAlert/ErrorAlert";
import ComplaintList from "../components/Complaints/ComplaintList/ComplaintList";

const ComplaintsPage = () => {
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadComplaints = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await complaintService.getAll();
      setComplaints(data || []);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadComplaints();
  }, []);

  const handleStatusChange = async (complaint, actionPayload) => {
    try {
      await complaintService.updateComplaint(complaint._id, actionPayload);
      toast.success("Жалоба обновлена");
      await loadComplaints();
    } catch (e) {
      toast.error(e?.response?.data?.message || "Ошибка обновления жалобы");
    }
  };

  return (
    <>
      <h1 className="mb-3">Жалобы</h1>
      <Card>
        <Card.Body>
          {loading && !complaints.length ? (
            <LoadingSpinner />
          ) : (
            <>
              <ErrorAlert error={error} />
              <ComplaintList
                complaints={complaints}
                onAction={handleStatusChange}
              />
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default ComplaintsPage;
